import { render, staticRenderFns } from "./ReviewsLeaveBtn.vue?vue&type=template&id=b0ec8358&scoped=true&"
import script from "./ReviewsLeaveBtn.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewsLeaveBtn.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewsLeaveBtn.vue?vue&type=style&index=0&id=b0ec8358&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ec8358",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0ec8358')) {
      api.createRecord('b0ec8358', component.options)
    } else {
      api.reload('b0ec8358', component.options)
    }
    module.hot.accept("./ReviewsLeaveBtn.vue?vue&type=template&id=b0ec8358&scoped=true&", function () {
      api.rerender('b0ec8358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewsLeaveBtn.vue"
export default component.exports